import styled from "styled-components"

export const RedeemIndexStyle = styled.div`
    padding: ${props => props.theme.space.paddingLG}px;
    margin: 0 auto;
`